import { useFilterQuoteTransportContext } from "./filter-quote-transport.context";

export function FilterQuoteTransport() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterQuoteTransportContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}